import { Button, ColumnLayout, FormField, Flashbar, Icon, Modal, Select } from 'AWS-UI-Components-React';
import React from 'react';
import { deepClone } from '../../../utilities';

import { getJSClient } from '../../js_client';

export class NewValidationWindow extends React.Component {
  constructor(props) {
    super(props);

    const { simulation } = this.props;

    this.state = {
      validated: false,
      errorText: '',
      disableSubmit: false,
      params: {
        simulationId: simulation.id,
        startMonth: simulation.startMonth,
        endMonth: simulation.endMonth,
        validationTestRunMonths: simulation.validationTestRunMonths
          ? simulation.validationTestRunMonths.toString()
          : '3',
      },
    };

    this.client = getJSClient();
  }

  validate = () => {
    let params = this.state.params;

    if (!this.validateTestRunMonths(params)) {
      this.setState({
        validated: false,
        errorText: `Validation Test Periods must be a value between 1 and 12.`,
      });
      return false;
    }

    this.setState({ validated: true, errorText: '' });
    return true;
  };

  validateTestRunMonths = (params) => {
    const months = parseInt(params.validationTestRunMonths);
    return !isNaN(months) && !(months < 1 || months > 12);
  };

  setValidationTestRunMonths = (event) => {
    let params = deepClone(this.state.params);
    params['validationTestRunMonths'] = event.detail.selectedOption.id.toString();
    this.setState({ params: params }, this.validate);
  };

  onSubmit = () => {
    if (this.validate()) {
      let params = deepClone(this.state.params);
      params['validationTestRunMonths'] = parseInt(params['validationTestRunMonths']);

      const payload = {
        snapshotId: params.simulationId,
        startMonth: params.startMonth,
        endMonth: params.endMonth,
        validationTestRunMonths: params.validationTestRunMonths,
      };

      this.setState({ disableSubmit: true });
      this.client.runValidations(this.onRunValidationSuccess, this.onRunValidationFailure, payload);
    }
  };

  onRunValidationSuccess = () => {
    this.setState({
      validated: false,
      errorText: '',
      flashItems: [
        {
          header: 'Validation tests triggerred. Please refresh this page in a few minutes to see the results.',
          type: 'success',
          dismissible: true,
        },
      ],
    });
  };

  onRunValidationFailure = (error) => {
    console.log(error);
    this.setState({
      errorText: 'Simulation failed to start. This might be because your simulation name is already in use.',
      disableSubmit: false,
      flashItems: [
        {
          header: 'An error has occurred while running validation tests.',
          type: 'error',
          dismissible: true,
        },
      ],
    });
  };

  onCancel = () => {
    this.setState({ flashItems: [] });
    this.props.onCancel();
  };

  generateValidationTestRunMonthOptions = () => {
    return Array(12)
      .fill()
      .map((_, i) => {
        return { id: i + 1, label: i + 1 };
      });
  };

  render() {
    const { params, flashItems, disableSubmit } = this.state;

    const { simulationId, startMonth, endMonth, validationTestRunMonths } = params;

    const validationTestResultOptions = this.generateValidationTestRunMonthOptions();
    const selectedOption = validationTestResultOptions.find(
      (item) => item.id.toString() === validationTestRunMonths
    );    

    return (
      <Modal
        visible={true}
        size="large"
        header="Run Validation Tests"
        expandToFit={true}
        onDismiss={this.onCancel}
        footer={
          <div>
            {this.state.errorText && (
              <span className="awsui-util-status-negative">
                <Icon name="status-negative" /> {this.state.errorText}
              </span>
            )}
            <span className="awsui-util-f-r">
              <Button text="Cancel" onClick={this.onCancel} />
              <Button variant="primary" text="Run Validation" onClick={this.onSubmit} disabled={disableSubmit} />
            </span>
          </div>
        }
        content={
          <div>
            <FormField label={'Simulation Id'}>
              <ColumnLayout className={'awsui-util-mb-xxl'} columns={2}>
                <div data-awsui-column-layout-root="true">
                  <div className="awsui-util-spacing-v-s">
                    <div>{simulationId}</div>
                  </div>
                </div>
              </ColumnLayout>
            </FormField>
            <FormField label={'Data Range'}>
              <ColumnLayout className={'awsui-util-mb-xxl'} columns={2}>
                <div data-awsui-column-layout-root="true">
                  <div className="awsui-util-spacing-v-s">
                    <div>
                      <ul>
                        <li>Start Month - {startMonth}</li>
                        <li>End Month - {endMonth}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ColumnLayout>
            </FormField>
            <div className={'awsui-util-mb-xxl'}>
              <FormField
                label="Validation Test Periods"
                description={'No of months from end date for which validation tests are to be run.'}
              >
                <ColumnLayout className={'awsui-util-mb-xxl'} columns={2}>
                  <div data-awsui-column-layout-root="true">
                    <Select
                      options={validationTestResultOptions}
                      selectedOption={selectedOption}
                      onChange={this.setValidationTestRunMonths}
                    />
                  </div>
                </ColumnLayout>
              </FormField>
              <Flashbar items={flashItems} />
            </div>
          </div>
        }
      />
    );
  }
}

export default NewValidationWindow;



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/new_validation_window.jsx